import * as React from "react";
import KenApplicationForm from "../../Components/KenApplicationForm";
import FormHeader from "./Components/FormHeader";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

function ApplicationForm() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <FormHeader />
      <KenApplicationForm />
    </LocalizationProvider>

  );
}

export default ApplicationForm;
